module.exports = __webpack_public_path__ + "static/revolution-in-the-valley-dd03c866e2686849ecff5faeddb63f9d.jpg";